const ARTICLE_BOOKMARKS_STORAGE_KEY = "trw-article-bookmarks-v1";
const ARTICLE_BOOKMARKS_DATA_STORAGE_KEY = "trw-article-bookmarks-data-v1";

function safeJsonParse(value, fallback) {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
}

export function readBookmarkedPostIds() {
  if (typeof window === "undefined") return [];
  const parsed = safeJsonParse(
    window.localStorage.getItem(ARTICLE_BOOKMARKS_STORAGE_KEY),
    []
  );
  return Array.isArray(parsed) ? parsed.map((v) => String(v)) : [];
}

export function writeBookmarkedPostIds(ids) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ARTICLE_BOOKMARKS_STORAGE_KEY, JSON.stringify(ids));
  window.dispatchEvent(new Event("storage"));
}

export function readBookmarkedPosts() {
  if (typeof window === "undefined") return [];
  const parsed = safeJsonParse(
    window.localStorage.getItem(ARTICLE_BOOKMARKS_DATA_STORAGE_KEY),
    []
  );
  return Array.isArray(parsed) ? parsed : [];
}

function writeBookmarkedPosts(posts) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ARTICLE_BOOKMARKS_DATA_STORAGE_KEY, JSON.stringify(posts));
  window.dispatchEvent(new Event("storage"));
}

function createBookmarkedPostEntry(post, metadata = {}) {
  return {
    ...post,
    __bookmarkId: String(post.id ?? post.slug ?? post.link ?? ""),
    __bookmarkCategoryLabel: metadata.categoryLabel || "",
    __bookmarkCategorySlug: metadata.categorySlug || "",
    __bookmarkCategoryLink: metadata.categoryLink || "",
  };
}

export function upsertBookmarkedPost(post, metadata = {}) {
  const bookmarkId = String(post.id ?? post.slug ?? post.link ?? "");
  if (!bookmarkId || typeof window === "undefined") return;

  const currentPosts = readBookmarkedPosts();
  const nextPost = createBookmarkedPostEntry(post, metadata);
  const getId = (entry) => String(entry.__bookmarkId ?? entry.id ?? entry.slug ?? entry.link ?? "");

  const nextPosts = currentPosts.some((entry) => getId(entry) === bookmarkId)
    ? currentPosts.map((entry) => (getId(entry) === bookmarkId ? nextPost : entry))
    : [...currentPosts, nextPost];

  writeBookmarkedPosts(nextPosts);
}

export function removeBookmarkedPost(bookmarkId) {
  if (typeof window === "undefined") return;
  const getId = (entry) => String(entry.__bookmarkId ?? entry.id ?? entry.slug ?? entry.link ?? "");
  const nextPosts = readBookmarkedPosts().filter(
    (entry) => getId(entry) !== String(bookmarkId)
  );
  writeBookmarkedPosts(nextPosts);
}

